import {ApiOrderState, GetOrderResponse} from '../../types/orderResponse';
import {Order} from '../../models/order';
import convertOrderResponseItemToOrderItem from './convertOrderResponseItemToOrderItem';

export const convertOrderResponseToOrder = (data: GetOrderResponse): Order => {
    const order = data.order;
    const {shipping_address, state, increment_id: orderNumber} = order;

    const orderState = state.toUpperCase() as ApiOrderState;

    return {
        uuid: order.uuid,
        invoiceUuid: order.invoice_uuid,
        orderNumber: orderNumber,
        state: orderState,
        createdAt: new Date(order.created_at),
        items: Object.values(order.items).map(item =>
            convertOrderResponseItemToOrderItem(item)
        ),
        canEdit: [
            ApiOrderState.NEW,
            ApiOrderState.PENDING_PAYMENT,
            ApiOrderState.PROCESSING,
        ].includes(orderState),
        canCancel: [ApiOrderState.NEW, ApiOrderState.PENDING_PAYMENT].includes(
            orderState
        ),
        isCanceled: orderState === ApiOrderState.CANCELED,
        isPaid: ![
            ApiOrderState.NEW,
            ApiOrderState.CANCELED,
            ApiOrderState.PENDING_PAYMENT,
            ApiOrderState.PAYMENT_REVIEW,
            ApiOrderState.CLOSED,
        ].includes(orderState),
        isRefunded: orderState === ApiOrderState.CLOSED,
        isComplete: orderState === ApiOrderState.COMPLETE,
        shippingAddress: {
            city: shipping_address.city,
            country_id: shipping_address.country_id,
            telephone: shipping_address.telephone,
            firstname: shipping_address.firstname,
            lastname: shipping_address.lastname,
            postcode: shipping_address.postcode,
            street: shipping_address.street[0] ?? '',
            houseNumber: shipping_address.street[1] ?? '',
            addition: shipping_address.street[2] ?? '',
        },
    };
};
